/* eslint-disable */

import * as clientService from "./httpsClient";

export const getOriginTransportation = async (accessToken, params) => {
  try {
    const domain = `origintransportations`;
    return await clientService.getApi(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const create = async (accessToken, body) => {
  try {
    const domain = `origintransportations`;
    return await clientService.postApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const createImages = async (accessToken, body) => {
  try {
    const domain = `origintransportations/upload-images`;
    return await clientService.postApiFromData(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const updateImages = async (accessToken, body) => {
  try {
    const domain = `origintransportations/update-images`;
    return await clientService.postApiFromData(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const updateStatus = async (accessToken, body) => {
  try {
    const domain = `origintransportations/update-status-origin-transportation`;
    return await clientService.putApiWithHandlerError(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const update = async (accessToken, body) => {
  const { id } = body;
  try {
    const domain = `origintransportations/` + id;
    return await clientService.putApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const getOriginTransportationById = async (accessToken, id, params) => {
  try {
    const domain = `origintransportations/${id}`;
    return await clientService.getApi(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const exportCheckList = async (accessToken, params) => {
  try {
    const domain = `origintransportations/export-checklist`;
    return await clientService.exportExcel(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const exportCustomer = async (accessToken, params) => {
  try {
    const domain = `origintransportations/export-customs`;
    return await clientService.exportExcel(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const exportOriginTransport = async (accessToken, params) => {
  try {
    const domain = `origintransportations/export-origintransportation`;
    return await clientService.exportExcel(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const exportDestinationDeliveryExcel = async (accessToken, params) => {
  try {
    const domain = `origintransportations/export-destination-delivery`;
    return await clientService.exportExcelPost(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const deletePackageOriginTransportation = async (accessToken, body) => {
  try {
    const domain = `origintransportations/delete-all`;
    return await clientService.postApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};
